"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stediJsonata = void 0;
const jsonata_1 = __importDefault(require("@stedi/jsonata"));
const jsonata_2 = __importDefault(require("jsonata"));
const dateTime_1 = require("./bindings/dateTime");
const convertDateTime = __importStar(require("./functions/convertDateTime"));
const currentDateTime = __importStar(require("./functions/currentDateTime"));
const lookupTable = __importStar(require("./functions/lookupTable"));
const uuid = __importStar(require("./functions/uuid"));
/**
 * Returns JSONata expression enhanced with Stedi's functions and bindings.
 *
 * @param expression raw JSONata expression to be evaluated
 * @returns jsonata.Expression
 */
const stediJsonata = (expression, useFastFork) => {
    const jsonataExpression = useFastFork ? (0, jsonata_1.default)(expression) : (0, jsonata_2.default)(expression);
    jsonataExpression.registerFunction(uuid.name, uuid.implementation);
    jsonataExpression.registerFunction(convertDateTime.name, convertDateTime.implementation, convertDateTime.signature);
    jsonataExpression.registerFunction(currentDateTime.name, currentDateTime.implementation, currentDateTime.signature);
    jsonataExpression.registerFunction(lookupTable.name, (table, filterKeys, filterPredicates, options) => lookupTable.implementation({
        table,
        filterKeys,
        filterPredicates,
        options,
    }), lookupTable.signature);
    jsonataExpression.assign("dateTime", dateTime_1.dateTime);
    return jsonataExpression;
};
exports.stediJsonata = stediJsonata;
